import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

class Wrapper extends React.PureComponent {
  static defaultProps = {
    initialDelay: 2,
    delay: 0,
    spring: {
      type: 'spring',
      stiffness: 220,
      damping: 50,
      mass: 3,
    },
  };

  static isInitial = true;

  render() {
    const {
      className,
      children,
      isAnimationStarted,
      onExitFinish,
      shouldSkipEnterAnimation,
      initialDelay,
      delay,
      spring,
    } = this.props;

    Wrapper.isInitial = false;

    return (
      <motion.div
        className={className}
        onAnimationComplete={e => {
          if (e === 'enter') {
            onExitFinish();
          }
        }}
        variants={{
          initial: { width: '0' },
          enter: {
            width: '100%',
            transition: {
              ...spring,
            },
          },
          exit: {
            width: '0%',
            transition: {
              ...spring,
              delay: 1,
            },
          },
        }}
        transition={spring}
        animate={
          isAnimationStarted
            ? shouldSkipEnterAnimation
              ? ''
              : 'enter'
            : 'exit'
        }
        initial={'initial'}
      >
        {React.Children.toArray(children)}
      </motion.div>
    );
  }
}

export default styled(Wrapper)`
  position: fixed;
  top: 0;
  left: auto;
  right: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  direction: rtl;
  z-index: 100;
  opacity: ${({ shouldSkipEnterAnimation }) =>
    shouldSkipEnterAnimation ? 0 : 1};
  display: ${({ shouldSkipEnterAnimation }) =>
    shouldSkipEnterAnimation ? 'none' : 'block'};

  ${props =>
    props.isAnimationStarted &&
    css`
      left: 0;
      right: auto;
      direction: ltr;
    `}
`;
